module.exports={
    logout  : "खाता रद्द करें",
    my      :'मेरा',
    scqx    :'अनुमतियाँ मिटाएँ',
    qxgl    :'अधिकार प्रबंधन',
    qdzxzhm :'क्या आप खाता को रद्द करने के लिए यकीन है?',
    qtxkh   :'कृपया कार्ड संख्या भरें',
    qd      :'निर्धारित करें',
    qx      :'रद्द करें',
    gb      :'बन्द करें',
    kh      :'कार्ड संख्या',
    kmewm   :'QR कोड खोलने के द्वार',
    dl      :'[degrees] in [radians]',
    name    :'उपयोक्ता नाम',
    qtxname :'कृपया उपयोक्ता नाम भरें',
    pwas    :'पासवर्ड',
    qtxpwas :'कृपया पासवर्ड भरें',
    tj      :'Submit',
    zczh    :'रेजिस्टार्ड खाता',
    zc      :'register',
    sjhm    :'phone number',
    qtxsjhm :'Please fill in your mobile phone number',
    yzm     :'परीक्षण कोड',
    qtxyzm  :'कृपया सत्यापन कोड भरें',
    yyzhqqdl:'You already have an account. Go and log in',
    hqyzm   :'सत्यापन कोड प्राप्त करें',
    zccg    :'लागइन सफल होता है',
    zcsb    :'लागइन असफल',
    fscg    :'सफलतापूर्वक भेजा गया',
    fssb    :'भेजने में असफल',
    yhycz   :'प्रयोक्ता पहिले से मौजूद है',


    xgmm    : "Change Password",
    zhmm    :'पासवर्ड पुनः प्राप्त करें',
    qrmm    :'पासवर्ड यकीन करें',
    zhyxmm  :"पासवर्ड मेलबाक्स पुनः प्राप्त करें",
    yxyzm   :'Email verification code',
    hqyxyzm :'मेलबाक्स परीक्षण कोड प्राप्त करें',
    zzmmyx  :'पासवर्ड मेलबाक्स रिसेट करें',
    lcmmbyc :'दो पासवर्ड अक्षम हैं',
    xgcg    :'Modified successfully',
    xgsb    :'परिवर्तन असफल',
    qtxyxyx  :'Please fill in a valid email address',
    lsmhhq  :'60 सेकंड के बाद पुनः प्राप्त करें',
    hqyyyzmcg:'मेलबाक्स परीक्षण कोड सफलतापूर्वक प्राप्त किया',
    zhmmbd  :'गलत खाता पासवर्ड'
}